// Resolves Mongo user _ids (the raw strings stored on Sanity
// like/follow documents) into displayable {_id, username, avatarImage}
// objects, via the backend's batch endpoint. This has to go through
// the Express/Mongo backend rather than Sanity — Sanity has no user
// documents of its own to look these up against.
//
// Uses userBatch from utils/APIRoutes, same pattern as userSearch.
// If your APIRoutes.js doesn't have this yet, add it alongside
// userSearch:
//   export const userBatch = `${host}/api/users/batch`;

import apiClient from '../utils/apiClient';
import { userBatch } from '../utils/APIRoutes';

export async function fetchUsersByIds(ids) {
  const uniqueIds = [...new Set((ids || []).filter(Boolean))];
  if (uniqueIds.length === 0) return [];

  try {
    const { data } = await apiClient.get(userBatch, {
      params: { ids: uniqueIds.join(',') },
    });
    return data.users || [];
  } catch (err) {
    throw new Error(err.response?.data?.message || 'Batch user fetch failed');
  }
}